import { useNavigate } from 'react-router-dom';
import AvatarUser from '../../components/AvatarUser';
import { useFilterApp } from '../../contexts/FilterApp';
import { useParamsContext } from '../../contexts/ParamsContext';
import { useAtendentesContext } from './Context';
import { Calendar, ChevronRight, TriangleAlert, UsersRound } from 'lucide-react';

export default function AtendentesList() {
    const { atendentes, loading, error, fetchAtendentes } = useAtendentesContext();
    const { setAttendantId } = useFilterApp();
    const { setParams } = useParamsContext();
    const navigate = useNavigate();

    const openAgendaSettings = (uid: string) => {
        setAttendantId(uid);
        navigate(`/atendentes?action=agenda-settings&id=geral&attendantId=${encodeURIComponent(uid)}`);
    };

    if (loading) {
        return (
            <div className="space-y-2 px-2" aria-busy="true">
                {[0, 1, 2].map((item) => (
                    <div key={item} className="sf-skeleton h-16" />
                ))}
            </div>
        );
    }

    if (error && !atendentes.length) {
        return (
            <div className="sf-state">
                <TriangleAlert aria-hidden />
                <h2>Não foi possível carregar os atendentes</h2>
                <button type="button" className="btn btn-primary btn-sm" onClick={() => void fetchAtendentes()}>
                    Tentar novamente
                </button>
            </div>
        );
    }

    if (!atendentes.length) {
        return (
            <div className="sf-state">
                <UsersRound aria-hidden />
                <h2>Nenhum atendente</h2>
                <p>Adicione quem faz os atendimentos para configurar agenda e comissão.</p>
                <button type="button" className="btn btn-primary btn-sm" onClick={() => setParams({ action: 'add' })}>
                    Adicionar atendente
                </button>
            </div>
        );
    }

    return (
        <div className="sf-page px-2">
            <ul className="sf-group [--sf-row-inset:4rem]">
                {atendentes.map((row) => (
                    <li key={row.uid}>
                        <div className="sf-row !p-0">
                            <button
                                type="button"
                                className="sf-row min-w-0 flex-1 !pr-2"
                                onClick={() => setParams({ action: 'edit', id: row.uid })}
                            >
                                <AvatarUser
                                    photoURL={row.photoURL}
                                    name={row.displayName || 'Atendente'}
                                    size="h-10 w-10 !text-sm"
                                />
                                <span className="sf-row-body">
                                    <span className="sf-row-title">{row.displayName || row.email || 'Sem nome'}</span>
                                    <span className="sf-row-sub">
                                        {row.email}
                                        {!!row.email && !row.emailVerified && (
                                            <span className="text-warning"> · não verificado</span>
                                        )}
                                    </span>
                                    <span className="sf-tags">
                                        {row.type === 'admin' && (
                                            <span className="sf-tag" data-tone="blue">
                                                Administrador
                                            </span>
                                        )}
                                        <span className="sf-tag" data-tone="gray">
                                            Comissão {Number(row.comissao) || 0}%
                                        </span>
                                    </span>
                                </span>
                                <ChevronRight className="sf-chevron" aria-hidden />
                            </button>
                            <button
                                type="button"
                                className="sf-link mr-2 shrink-0"
                                onClick={() => openAgendaSettings(row.uid)}
                                aria-label={`Agenda de ${row.displayName || 'atendente'}`}
                                title="Editar agenda"
                            >
                                <Calendar aria-hidden />
                                <span className="hidden sm:inline">Agenda</span>
                            </button>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
}
